window.onload = function() {
    const images = document.querySelectorAll('.product-image img');
    images.forEach(img => {
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;
        const aspectRatio = imgWidth / imgHeight;

        // Adjust image alignment based on aspect ratio
        if (aspectRatio > 1) {
            img.style.objectPosition = 'center center';  // Horizontal images
        } else {
            img.style.objectPosition = 'center center';  // Vertical images
        }
    });
}
